import {graphql} from 'react-relay'

export const applySecretQuery = graphql`
  query EditPipelinePageApplySecretQuery($projectLocator: String!, $input: String!) {
    addSecureToken(projectLocator: $projectLocator, input: $input)
  }
`
